import { Box, Grid, Stack, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
export const HomePage = () => {
  const navigate = useNavigate();
  let data = [
    {
      id: 1,
      heading: "Fill in requirements",
      message:
        "Fill in customer and resin requirements. For new resin, upload CXF file from iMatch.",
    },
    {
      id: 2,
      heading: "Input target color",
      message:
        "Upload target color CXF file from iMatch or choose existing color from color library.",
    },
    {
      id: 3,
      heading: "Download report",
      message:
        "Let the tool calculate results that you can view and download right afterwards.",
    },
  ];
  return (
    <Box sx={{ textAlign: "center" }} className="contentPage">
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <Box
          sx={{
            fontFamily: "Ubuntu",
            fontSize: "34px",
            fontWeight: "500",
            width: "400px",
            marginTop: "70px",
            marginBottom: "20px",
          }}
        >
          Hello, which color would you like to produce with recycled resin
          today?
        </Box>
        <Box
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            width: "410px",
            color: "#858585",
          }}
        >
          This system allows you to predict if a target color is achievable with
          recycled resin.
        </Box>
        <Button
          onClick={() => navigate("/evaluate-achievable-color", { replace: true })}
          sx={{
            mr: 1,
            width: "22%",
            height: "40px",
            borderRadius: "24px",
            border: "1px solid #385DAE",
            background: "linear-gradient(90deg, #3A5DAE 0%, #4EC3E0 100%)",
            border: "1px solid",
            color: "#FFFFFF",
            textTransform: "none",
            fontFamily: "Source Sans Pro",
            marginTop: "30px",
            marginBottom: "80px",
          }}
        >
          Start
        </Button>
        <Box sx={{ fontSize: "22px", fontWeight: "600", marginBottom: "20px" }}>
          How to predict achievable colors
        </Box>
        <Stack direction="row" width={"95%"} spacing={3}>
          {data.map((e) => {
            return (
              <Grid
                key={e.id}
                container
                direction="column"
                justifyContent="center"
                columnSpacing={18}
                sx={{
                  background: "rgba(0, 0, 0, 0.04)",
                  fontFamily: "Source Sans Pro",
                }}
              >
                <Box
                  sx={{
                    color: "#858585",
                    fontSize: "16px",
                    fontWeight: 600,
                    padding: "8px 16px 16px 16px",
                  }}
                >
                  STEP {e.id}
                </Box>
                <Box
                  sx={{
                    color: "#303C43",
                    fontSize: "20px",
                    fontWeight: 600,
                    padding: "8px 16px 0px 16px",
                  }}
                >
                  {e.heading}
                </Box>
                <Box
                  sx={{
                    color: "#858585",
                    fontSize: "16px",
                    fontWeight: 400,
                    padding: "16px",
                  }}
                >
                  {e.message}
                </Box>
              </Grid>
            );
          })}
        </Stack>
      </Grid>
    </Box>
  );
};
